import { type Discount, DiscountType } from '@carvana/merch-contracts';

type DiscountTotals = {
  isInExcludedState: boolean;
  totalDiscount: number;
  totalSiteWideDiscount: number;
  tradeIncentive: number;
};

type OwnArgs = {
  hasActiveTrade: boolean;
  isTradeInApplied: boolean;
};

export default function computeDiscountTotals(
  discounts: Array<Discount>,
  { hasActiveTrade, isTradeInApplied }: OwnArgs
): DiscountTotals {
  return discounts.reduce<DiscountTotals>(
    (acc, discount) => {
      if (discount.shouldApplyToStickerPrice) {
        acc.totalDiscount += discount.amount;

        if (discount.type === DiscountType.TradeIncentive) {
          const shouldApplyTradeIncentive = hasActiveTrade && isTradeInApplied;

          if (hasActiveTrade) {
            acc.tradeIncentive = discount.amount;
          }

          if (!shouldApplyTradeIncentive) {
            // Keep the amount available for advertising, but don't apply it to the total.
            acc.totalDiscount -= discount.amount;
          }
        }
      } else {
        acc.isInExcludedState = true;
      }

      if (
        discount.type === DiscountType.Campaign ||
        discount.type === DiscountType.CyberMondayDeal
      ) {
        acc.totalSiteWideDiscount += discount.amount;
      }

      return acc;
    },
    {
      isInExcludedState: false,
      totalDiscount: 0,
      totalSiteWideDiscount: 0,
      tradeIncentive: 0
    }
  );
}
